module.exports = __webpack_public_path__ + "img/72.770178b1.svg";